import {useEffect} from 'react'
import {OrgModalHeader} from './OrgModalHeader'
import {OrgModalFormWrapper} from './OrgModalFormWrapper'

export const OrgModal = ({ getUser, user, setOpenOrgModal}) => {

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-650px`}>
          <div className='modal-content'>
            <OrgModalHeader setOpenOrgModal={setOpenOrgModal} />
            <div className={`modal-body scroll-y mx-5  mx-xl-15 my-7`}>
              <OrgModalFormWrapper getUser={getUser} user={user} setOpenOrgModal={setOpenOrgModal} />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'/>
    </>
  )
}
